export enum EnvironmentApplication {
  Loft = 'loft',
  Studio = 'studio',
  Viewer = 'viewer',
  All = ''
}
